/* eslint react/prop-types: 0 */

import React , { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { Form, FormGroup, Label } from "reactstrap";
import { YearList } from "../../component/Utils";
import { getDataAction } from "../../config/redux/action";
import { RASIO_KEUANGAN, RASIO_KEUANGAN_YEAR } from "../../constants";
import { isBiro } from "../../utils/helper";

import API from "./../../utils/API";
import FormFilterDashboard from "./FormFilterDashboard";


export const RasioKeuangan = (props) => {
  const dispatch = useDispatch();
  const onChange = (type, data) => dispatch({ type, data });
  const [data, setData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [rawData, setRawData] = React.useState([]);
  const filter = useSelector((state) => state.filterReducer);
  const [loadingApi, setLoadingApi] = useState(true);

  const filterDashboard = useSelector(
    (state) => state.filterDashboard
  );

  const chartFilterDashboard = useSelector(
    (state) => state.chartFilterDashboard
  );
  const loadData = async () => {
      try {
          var url =
            `/indikator-kesehatan/aspek-keuangan?type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${chartFilterDashboard.bumd}&startYear=${chartFilterDashboard.startYear}&endYear=${chartFilterDashboard.endYear}`;
        url = url.trim();
        const r = await API.get(url);
        const d = r.data;
        setData(d);
        setRawData(d);
  
      } catch (err) {
        console.error(err.response.data);
      }
  };

    React.useEffect(() => {
      loadData();
    }, [
      chartFilterDashboard
    ]); 

  return (
    <div className=" card container py-3 border-0 h-100 ">
      <h3>Rasio Keuangan</h3>
          <div className="row">
            <div className="col py-3">
              {chartFilterDashboard.bumd == ""  ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center", fontStyle: "italic" }}>
                    Data tidak tersedia
                  </td>
                </tr>
              ) : (
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      <th>Perusahaan</th>
                      <th>Tahun</th>
                      <th>Roe</th>
                      <th>Roi</th>
                      <th>Bopo</th>
                      <th>Ebitda</th>
                      <th>Cash Ratio</th>
                      <th>Current Ratio</th>
                      <th>Period Tahun Buku</th>
                      <th>Period Perbaikan</th>
                      <th>TATO Tahun Buku</th>
                      <th>TATO Perbaikan</th>
                      <th>TMSTA</th>
                    </tr>
                  </thead>
                  {data?.map((d, i) => (
                    <tbody>
                      <tr>
                        <td>{d.perusahaanName}</td>
                        <td className="text-center">{d.year}</td>
                        <td className="text-right">{d.hasilRoe}</td>
                        <td className="text-right">{d.hasilRoi}</td>
                        <td className="text-right">{d.hasilBopo}</td>
                        <td className="text-right">{d.hasilEbitda}</td>
                        <td className="text-right">{d.hasilCashRatio}</td>
                        <td className="text-right">{d.hasilCurrentRatio}</td>
                        <td className="text-right">{d.hasilPeriodTahunBuku}</td>
                        <td className="text-right">{d.hasilPeriodPerbaikan}</td>
                        <td className="text-right">{d.hasilTatoTahunBuku}</td>
                        <td className="text-right">{d.hasilTatoPerbaikan}</td>
                        <td className="text-right">{d.hasilTmsTA}</td>
                      </tr>
                    </tbody>
                  ))}

                </table>
              )}
              <hr />
            </div>
          </div>
    </div>
  );
};
